module.exports = __webpack_public_path__ + "img/hill44.fc4de20c.jpg";